import script from "./SiteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteButton.vue?vue&type=script&setup=true&lang=js"

import "./SiteButton.vue?vue&type=style&index=0&id=19e1a33c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e1a33c"]])

export default __exports__